import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, OnChanges, TemplateRef, ViewChild, ElementRef} from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../services/mysql.service';

import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {Observable, Subject, Subscription, map} from 'rxjs';

import { FileUploaderService } from './../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
// sycfusion dialog 
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { DialogUtility } from '@syncfusion/ej2-popups';
import { EmitType } from '@syncfusion/ej2-base';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { JobSubject } from './../../../shared/models/jobSubject.model';

@Component({
  selector: 'app-create-job-3',
  templateUrl: './create-job-3.component.html',
  styleUrls: ['./create-job-3.component.css']
})
export class CreateJob3Component implements OnInit {

  nav: any;
  currentUserVAR: any;
  sessionUserId: any;
  sessionBrandId: any;
  job: Object;
  JobStep2ID: any;
  model: any;
  job_types: Object;
  job_type_locations: Object;
  count2: any;
  job_type_courts: Object;
  sent_job_type_location_id: any;
  job_type_document_types: Object;
  sent_job_type_court_id: any;
  job_type_affidavit_types: Object;
  sent_job_type_document_type_id: any;
  clients: Object;
  client_contacts: Object;
  sent_client_id: any;
  positionsMysql: any;
  subjects: any;
  job_type: Object;
  client: Object;
  clientInvoice: Object;
  clientContact: Object;
  bsModalRef: BsModalRef;
  modalRef: BsModalRef;

  dropdownSettings2 = {};

  afuConfig = {
    multiple: true,
    formatsAllowed: '.jpg,.png, .msg, .doc, .doc, .pdf, .mp3,',
    maxSize: '50',
    uploadAPI:  {
      url: this.gfunc.php_apiURL_SSL + '/uploadFiles.php',
      method: 'POST',
      headers: {
     'Content-Type' : 'text/plain;charset=UTF-8'
      },
    },
    theme: 'dragNDrop',
    hideProgressBar: false,
    hideResetBtn: true,
    hideSelectBtn: false
};
  job_status: Object;

 
  accept = '*'
  files:File[] = []
  progress:number

  url = this.gfunc.php_apiURL_SSL + '/uploadFiles.php'
  hasBaseDropZoneOver:boolean = false
  httpEmitter:Subscription;
  httpEvent:HttpEvent<{}>;
  lastFileAt:Date;
 
  sendableFormData:FormData; //populated via ngfFormData directive
 
  dragFiles:any;
  validComboDrag:any;
  lastInvalids:any;
  fileDropDisabled:any;
  maxSize:any;
  baseDropValid:any;
  job_id: any;
  tableData: any;
  client_contact: Object;
  job_subject_type: Object;
  job_plaintiff_type: Object;
  job_type_location: Object;
  job_type_court: Object;
  job_type_document: Object;
  job_type_affidavit: Object;
  subject_notes: Object;
  static returned: any; // from included components
  staffList: Object;
  trace_id: any;
  assignedList: Object;
  assigned_to_list: Object;
  assignedUsers: { user_id: number; item_text: string; }[];
  user_id: any;
  sessionUsername: any;
  report_brand_brand: Object;
  invoice_brand_brand: Object;
  report_brand_user: Object;
  current_subject_count: number;
  subjectValidationStatuses: any = {};
  subjectValidationIssues: any[] = [];
  subjectValidationPending = true;

  // SyncFusion Dialog
  @ViewChild('ejDialog') ejDialog: DialogComponent;
  // Create element reference for dialog target element.
  @ViewChild('container', { read: ElementRef }) container: ElementRef;
  // The Dialog shows within the target element.
  public targetElement: HTMLElement;
  JSON_job: any;
  returned_subjects: Object;
  DialogObj: any;
  newSubject: JobSubject;
  all_router_details: string;
  subjects_stages_only: Object;
  current_subject_stages_only_count: number;
  true_subject_count: number;


  constructor(private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router,
     public HttpClient:HttpClient,
     private fileUploader: FileUploaderService,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public gfunc: GlobalFunctionsService
    ) { 


      
     this.nav = document.querySelector('nav.navbar');
     

    // login vars
  // Set and Access login Session Variables
  this.gfunc.setLoginSessionVars(); // set in a global function file
  this.sessionUserId = this.gfunc.currentUserVAR.user_id;
  this.sessionUsername = this.gfunc.currentUserVAR.username;
  this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;
 
       // need to add this as routes does not work globally
       this.all_router_details = this.router.url;
       this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

       this.JobStep2ID = +this.route.snapshot.paramMap.get('job_id');
       this.job_id = +this.route.snapshot.paramMap.get('job_id');
   this.trace_id = this.job_id;
   // this.user_id = this.sessionUserId;

     }



  ngOnInit() {

    // This function is very important and now pauses then load the document correctly.
    setTimeout(() => {  
      console.log("A Simple Pause for subject tabs!"); 
      // console.log("Now Ready to load...");
   
      this.getJobSubjectsStagesOnly(this.job_id) // count stages to take from subjects to know the real count.
      // this.LoadDocument_DocumentCreated('FakeID', this.templateDocxName);
  }, 2000);


  this.getJobSubjects(this.job_id); // moved here to load the data properly.

   this.getJob(this.job_id);
   this.getJobTypes();
   this.getPositions();
   this.getJobStatusNames();
  // this.getJobTypeLocations(this.model.job_type_location_id); // loads default locations as nothing

 // this.refreshList(); // loads the file list (diretory) turned this off for now as too many errors




// drop down for assigned users
this.dropdownSettings2 = {
  singleSelection: false,
  idField: 'user_id',
  textField: 'first_name',
  selectAllText: 'Select All',
  unSelectAllText: 'UnSelect All',
  itemsShowLimit: 15,
  allowSearchFilter: true,
  enableCheckAll: true,
};

this.getBrandUsers('94'); // for the drop down

  }



// syncfusion dialog simple sample -- only counts subjects not stages
        // public onOpenDialog = function(event: any): void {
        //   this.DialogObj = DialogUtility.confirm({
        //     title: 'Require an Additional Subject',
        //     content: 'Press Create Subject below and a new subject will be created.',
        //     okButton: {  text: 'Create Subject', click: this.okClick.bind(this) },
        //     cancelButton: {  text: 'Cancel.', click: this.cancelClick.bind(this) },
        //     showCloseIcon: true,
        //     closeOnEscape: true,
        //     animationSettings: { effect: 'Zoom' }
        // });
        // }
        // private okClick(): void {
        //  //  alert('you clicked Yes, Please! are you really really sure??? Really');
        //  console.log(JSON.stringify(this.job) );
        //  console.log('Model: ' + this.model );
        //  this.JSON_job = JSON.stringify(this.job);
        //  // this.createJobSubjectsMultiple(this.JSON_job);



        //  this.createJobSubjectsMultiple(this.newSubject);
        //  this.DialogObj.hide();
        // }

        // private cancelClick(): void {
        //    // alert('you clicked Cancel button');
        //    this.DialogObj.hide();
        // }

// syncfusion dialog simple sample
public onOpenDialog = function(event: any): void {
  this.DialogObj = DialogUtility.confirm({
    title: 'Require an Additional Subject',
    content: 'Press Create Subject below and a new subject will be created.',
    okButton: {  text: 'Create Subject', click: this.okClick.bind(this) },
    cancelButton: {  text: 'Cancel.', click: this.cancelClick.bind(this) },
    showCloseIcon: true,
    closeOnEscape: true,
    animationSettings: { effect: 'Zoom' }
});
}
private okClick(): void {
 //  alert('you clicked Yes, Please! are you really really sure??? Really');
 console.log(JSON.stringify(this.job) );
//  console.log('Model: ' + this.model );
 this.JSON_job = JSON.stringify(this.job);
 // this.createJobSubjectsMultiple(this.JSON_job);



 this.createJobSubjectsMulipleJobButton(this.newSubject);
 this.DialogObj.hide();
}

private cancelClick(): void {
   // alert('you clicked Cancel button');
   this.DialogObj.hide();
}

 // create subjects
 public createJobSubjectsMultiple(model) {

  // I have now modified this function to carry across job type ids in the insert scrupt to the subject.
//  model.number_subjects = 1; // set to default so that only one is created here.


console.log('sentJobID: ' + model.job_id);

  this._demoService.createJobSubjectsMuliple(model).subscribe(
    data => {
      this.returned_subjects = data; // this is the retuned json upon creation.
      this.toastr.success('Subjects Saving... We have added your subject(s).');
      // API Updated to return JSON of last inserted ID: {"last_insert_id" : "232"}

    this.gfunc.globalJobEditStep3SkipRoute(model.job_id);
      // Setup annd the Currents before we redirec the page
      // Needs to be a Function to update the ObserveOnOperator.
      // this.newCTrace_id(this.latest_trace_id);
      // or this.cdata.changeCTrace_id("999");

     // this.router.navigate(['/admin/jobs/create-job-2/' + model.job_id + '']);

     // return true;


    },
    error => {
      // console.log('Should be form Model' + model);
      // console.error('Error Creating a Trace Project!');
      // this.toastr.error('Adding Subjects Failed :: Please try again! --- IS THIS AN ERROR!');
      this.toastr.success('Subjects Saving... We have added your subject(s).');
     // console.log(error(error));
      //return console.log(error);
     this.gfunc.globalJobEditStep3SkipRoute(model.job_id);
    }
  );
}



  // create subjects
  public createJobSubjectsMulipleJobButton(model) {

    // I have now modified this function to carry across job type ids in the insert scrupt to the subject.
  //  model.number_subjects = 1; // set to default so that only one is created here.


console.log('sentJobID: ' + model.job_id);

    this._demoService.createJobSubjectsMulipleJobButton(model).subscribe(
      data => {
        this.returned_subjects = data; // this is the retuned json upon creation.
        this.toastr.success('Subjects Saving... We have added your subject(s).');
        // API Updated to return JSON of last inserted ID: {"last_insert_id" : "232"}

      //  this.gfunc.globalJobViewSkipRoute(model.job_id);
        // Setup annd the Currents before we redirec the page
        // Needs to be a Function to update the ObserveOnOperator.
        // this.newCTrace_id(this.latest_trace_id);
        // or this.cdata.changeCTrace_id("999");

        let cb = {
          ...this.returned_subjects,
          ...model
        }
        this.gfunc.insertLog_CreateSubject(cb);
        this.gfunc.globalJobEditStep3SkipRoute(model.job_id);

       // return true;


      },
      error => {
        // console.log('Should be form Model' + model);
        // console.error('Error Creating a Trace Project!');
        this.toastr.error('Adding Subjects Failed :: Please try again!');
       // console.log(error(error));
        // this.toastr.success('Added New Subject!');

        this.gfunc.insertLog_CreateSubject_FAIL(model);

        //return console.log(error);
        this.gfunc.globalJobEditStep3SkipRoute(model.job_id);
      }
    );
  }



  getJobSubjects(job_id) {
    this.subjectValidationStatuses = {};
    this.subjectValidationIssues = [];
    this.subjectValidationPending = true;
    this._demoService.getJobSubjects(job_id).subscribe(
       data => { this.subjects = data;
        let res = data[0];
       // this.getSubjectNotes(res.subject_id);
        this.current_subject_count = Object(this.subjects).length; // counts the subjects.
        this.recalculateSubjectValidationState();
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

   refreshSubjectsAfterSetupSync(event?: any) {
    const jobId = event?.job_id || this.job_id;
    this.subjects = [];
    this.subjectValidationStatuses = {};
    this.subjectValidationIssues = [];
    this.subjectValidationPending = true;
    this.getJobSubjects(jobId);
    this.getJobSubjectsStagesOnly(jobId);
   }

   onSubjectValidationStatusChanged(status: any) {
    if (!status || !status.subject_id) {
      return;
    }

    this.subjectValidationStatuses[status.subject_id] = status;
    this.recalculateSubjectValidationState();
   }

   private recalculateSubjectValidationState() {
    const subjectsArray = Array.isArray(this.subjects) ? this.subjects : [];
    const openSubjects = subjectsArray.filter(subject => {
      const status = (subject?.job_status_code || subject?.job_status || '').toString().toUpperCase();
      return status !== 'CLOSED';
    });

    this.subjectValidationIssues = openSubjects
      .map(subject => this.subjectValidationStatuses[subject.subject_id])
      .filter(status => status && !status.valid);

    this.subjectValidationPending = openSubjects.length > 0
      && openSubjects.some(subject => !this.subjectValidationStatuses[subject.subject_id]);
   }



   getJobSubjectsStagesOnly(job_id) {
    this._demoService.getJobSubjectsStagesOnly(job_id).subscribe(
      data => {
        this.subjects_stages_only = data;
        let res = data[0];
        this.current_subject_stages_only_count = Object(this.subjects_stages_only).length; // counts the subjects.
        // this.getSubjectNotes(res.subject_id);


        this.true_subject_count = (this.current_subject_count - this.current_subject_stages_only_count);

      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  }





  getJob(job_id) {
    this._demoService.getJobID(job_id).subscribe(
       data => { this.job = data;
        this.job = data;
        let res = data[0];
       /*  this.getJobType(res.job_type_id);
        this.getClientMapping(res.client_id);
        this.getClientInvoice(res.client_invoice_id);
        this.getClientContactSharmans(res.client_contact_id);
        this.getJobSubjectType(res.job_subject_type_id);
        this.getJobPlaintiffType(res.job_plaintiff_type_id);
        this.getJobTypeLocation(res.job_type_location_id);
        this.getJobTypeCourt(res.job_type_court_id);
        this.getJobTypeDocument(res.job_type_document_type_id);
        this.getJobTypeAffidavit(res.job_type_affidavit_type_id);
        this.getJobAgentAssigned(res.job_id);
        this.getReportBrand(res.brand_report_id); // get company brand
        this.getInvoiceBrand(res.brand_invoice_id); // get company invoice brand
        this.getReportBrandUser(res.brand_report_user_id); // get report brand user
 */
        this.JSON_job = JSON.stringify(data);

    
                  // now set a new subject model
                  // this.newSubject = {
                  //   job_id: res.job_id,
                  //   job_reference_number: res.job_reference_number,
                  //   number_subjects: 1,
                  //   existing_subjects_count: this.current_subject_count, // set so that increments in sql correctly
                  //   // existing_subjects_count: 4, // set so that increments in sql correctly // testing was not showing in model
                  //   file_number: this.current_subject_count, // adds one in api loop
                  //   reference_number: res.reference_number,
                  //   created_by: this.gfunc.sessionUserId,
                  //   is_active: '1',
                  //   job_type_id: res.job_type_id,
                  //   job_type_location_id: res.job_type_location_id,
                  //   job_type_court_id: res.job_type_court_id,
                  //   job_type_document_type_id: res.job_type_document_type_id,
                  //   job_type_affidavit_type_id: res.job_type_affidavit_type_id,
                  //   job_status: res.job_status_code,
                  //   job_subject_type_id: res.job_subject_type_id,
                  //   job_service_rule_id: res.job_service_rule_id,
                  //   job_service_timeframe_id: res.job_service_timeframe_id,
                  //   subject_service_type_id: 1
                  //    };
          


                        // sets the default holder to create a new subject. May 2023 create new subject Button
                      this.newSubject = {
                        job_id: res.job_id,
                        job_reference_number: res.job_reference_number,
                        number_subjects: 1,
                        // existing_subjects_count: this.current_subject_count, // set so that increments in sql correctly
                        existing_subjects_count: this.true_subject_count, // Updated to true count to take subject stages in to consideration 2 May 2023
                        file_number: this.current_subject_count, // adds one in api loop
                        reference_number: res.reference_number,
                        created_by: this.gfunc.sessionUserId,
                        is_active: '1',
                        job_type_id: res.job_type_id,
                        job_type_location_id: res.job_type_location_id,
                        job_type_court_id: res.job_type_court_id,
                        job_type_document_type_id: res.job_type_document_type_id,
                        job_type_affidavit_type_id: res.job_type_affidavit_type_id,
                        job_status: res.job_status_code,
                        subject_service_type_id: 1,

                        // What Fields Am I missing for a subject... -- That are important -- add here 28/1/24
                        // Might need to add in the multiple version as well.
                        brand_report_user_id: res.brand_report_user_id,
                        brand_report_id: res.brand_report_id,
                        job_subject_type_id: res.job_subject_type_id,
                        job_service_rule_id: res.job_service_rule_id,
                        job_service_timeframe_id: res.job_service_timeframe_id,
                        service_company_name: res.service_company_name,
                        service_directors_name: res.service_directors_name,
                        service_prison_name: res.service_prison_name,
                        service_law_firm_name: res.service_law_firm_name,
                        service_solicitor_name: res.service_solicitor_name,
                        special_instructions_HTML: res.special_instructions_HTML


                          };
       

      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
  // BOF SHARMANS CALLS
  getJobTypes() {
    this._demoService.getJobTypes().subscribe(
       data => { this.job_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   getJobTypeLocations(job_type_id) {
    this._demoService.getJobTypeLocations(job_type_id).subscribe(
       data => { this.job_type_locations = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   sendJobTypeLocationsID(job_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.count2 = job_type_id;
    this.getJobTypeLocations(this.count2); // updates the selected job ID....
  
  
  
   console.log('sending Count:' + this.count2);
  }
  
  
  getJobTypeCourts(job_type_location_id) {
    this._demoService.getJobTypeCourts(job_type_location_id).subscribe(
       data => { this.job_type_courts = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   sendJobTypeCourtsID(job_type_location_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_location_id = job_type_location_id;
    this.getJobTypeCourts(this.sent_job_type_location_id); // updates the selected job ID....
  
  
  
   console.log('sending Location:' + this.sent_job_type_location_id);
  }
  
  
  getJobTypeDocumentTypes(job_type_court_id) {
    this._demoService.getJobTypeDocumentTypes(job_type_court_id).subscribe(
       data => { this.job_type_document_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   sendJobTypeDocumentTypesID(job_type_court_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_court_id = job_type_court_id;
    this.getJobTypeDocumentTypes(this.sent_job_type_court_id); // updates the selected job ID....
  
  
   console.log('sending Court Type:' + this.sent_job_type_court_id);
  }
  
  
  getJobTypeAffidavitTypes(job_type_document_type_id) {
    this._demoService.getJobTypeAffidavitTypes(job_type_document_type_id).subscribe(
       data => { this.job_type_affidavit_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   sendJobTypeAffidavitTypesID(job_type_document_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.sent_job_type_document_type_id = job_type_document_type_id;
    this.getJobTypeAffidavitTypes(this.sent_job_type_document_type_id); // updates the selected job ID....
  
   console.log('sending Doc Type:' + this.sent_job_type_document_type_id);
  }
  
  
  
  getClients() {
    this._demoService.getClients().subscribe(
       data => { this.clients = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   getClientContactsSharmans(client_id) {
    this._demoService.getClientContactsSharmans(client_id).subscribe(
       data => { this.client_contacts = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

   getClientContactSharmans(id) {
    this._demoService.getClientContactSharmans(id).subscribe(
       data => { this.client_contact = data; },
       err => console.error(err),
       // () => console.log('done loading candidate for update')
     );
   }

  
   sendClientID(client_id) {
   this.sent_client_id = client_id;
   this.getClientContactsSharmans(this.sent_client_id); // updates the selected job ID....
  
   console.log('sending Client ID:' + this.sent_client_id);
  }
  
  private getPositions() {
    this._demoService.getPositions()
      .subscribe(
        res => this.positionsMysql = res,
        err => console.error(err.status)
      );
  }


  private getJobStatusNames() {
    this._demoService.getJobStatusNames()
      .subscribe(
        res => this.job_status = res,
        err => console.error(err.status)
      );
  }
  
  
  
  
  // update was here for onit but moved for onchange
  updateJobStep2(model) {
    this._demoService.updateJobStep2(model).subscribe(
       data => { // this.trace_candidate_update = data;
         // refresh the list
        // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
       this.toastr.success('Job Updated');
       // Subject to reload the manager component parent.
      // TraceCandidateManagerComponent.returned.next(false);
      this.router.navigate(['/admin/jobs/create-job-3/' + model.job_id + '']);
                 return true;
       },
       error => {
        // console.error('Error saving Event!');
         this.toastr.error('Error saving Job!');
        return console.log(error);
       }
      // err => console.error(err),
      // () => console.log('done updates')
  );
  }




  // update was here for onit but moved for onchange
  updateJobSubject(model) {

    // first make a copy of subject and place in to subject_history table. // done on insert in PHP

model.updated_by = this.sessionUserId;
    this._demoService.updateJobSubject(model).subscribe(
       data => { // this.trace_candidate_update = data;
         // refresh the list
        // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
       this.toastr.success('Subject Updated');
       // Subject to reload the manager component parent.
      // TraceCandidateManagerComponent.returned.next(false);
      this.router.navigate(['/admin/jobs/create-job-3/' + model.job_id + '']);
                 return true;
       },
       error => {
        // console.error('Error saving Event!');
         this.toastr.error('Error saving Job!');
        return console.log(error);
       }
      // err => console.error(err),
      // () => console.log('done updates')


  );
  }



  getJobType(job_type_id) {
    this._demoService.getJobType(job_type_id).subscribe(
       data => { 
        this.job_type = data;
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }



// Get the name of job type from the ID
getClientMapping(client_id) {
  this._demoService.getClientMappingID(client_id).subscribe(
     data => {
       this.client = data;
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 // Get the name of job type from the ID
getClientInvoice(client_id) {
  this._demoService.getClientMappingID(client_id).subscribe(
     data => {
       this.clientInvoice = data;
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }



 // Get the name of job type from the ID
getClientContact(id) {
  this._demoService.getClientContactID(id).subscribe(
     data => {
       this.clientContact = data;
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 getJobSubjectType(job_subject_type_id) {
  this._demoService.getJobSubjectType(job_subject_type_id).subscribe(
     data => { this.job_subject_type = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 getJobPlaintiffType(job_plaintiff_type_id) {
  this._demoService.getJobPlaintiffType(job_plaintiff_type_id).subscribe(
     data => { this.job_plaintiff_type = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 getJobTypeLocation(job_type_location_id) {
  this._demoService.getJobTypeLocation(job_type_location_id).subscribe(
     data => { this.job_type_location = data;
      let res = data[0];
     // this.model.job_type_id = res.job_type_id;
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }

 getJobTypeCourt(job_type_court_id) {
  this._demoService.getJobTypeCourt(job_type_court_id).subscribe(
     data => { this.job_type_court = data; 
     // let res = data[0];
     // this.model.job_type_id = res.job_type_id;
     // this.getJobTypeLocations(res.job_type_id);
    
    
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }



 getJobTypeDocument(job_type_document_type_id) {
  this._demoService.getJobTypeDocument(job_type_document_type_id).subscribe(
     data => { this.job_type_document = data; 
      let res = data[0];
     // this.model.job_type_id = res.job_type_id;
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }


 
 getJobTypeAffidavit(job_type_affidavit_type_id) {
  this._demoService.getJobTypeAffidavit(job_type_affidavit_type_id).subscribe(
     data => { this.job_type_affidavit = data; 
      let res = data[0];
     // this.model.job_type_id = res.job_type_id;
    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }



 getSubjectNotes(subject_id) {
  this._demoService.getSubjectNotes(subject_id).subscribe(
    data => { this.subject_notes = data;
     // console.log("Done loadng USER");
     // console.log(this.users);
    },
    error => {
    //  console.error('Error Loading User!');
    //return console.log(error);
    }
  ); }




 // MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  this.modalRef = this.modalService.show(template);
}





// upload files

 cancel(){
  this.progress = 0
  if( this.httpEmitter ){
    console.log('cancelled')
    this.httpEmitter.unsubscribe()
  }
}

uploadFiles():Subscription{
  // apends the value to the form.
  this.sendableFormData.append('job_id', this.job_id);
  const req = new HttpRequest<FormData>(
    'POST',
    this.url,
    this.sendableFormData, {
    reportProgress: true , responseType: 'text'
  },
);

  return this.httpEmitter = this.HttpClient.request(req)
  .subscribe(
    event => {
      this.httpEvent = event;
      if (event instanceof HttpResponse) {
        delete this.httpEmitter;
        console.log('request done', event);
        // clears the form for upload
        this.files.length = 0;
        this.refreshList(); // refresh list.
      }
    },
    error => alert('Error Uploading Files: ' + error.message)
  )
}

private refreshList(): void {
  // notice the update here for traces
this.fileUploader.getJobFiles(this.job_id).subscribe(res => this.displayTableData(res));

}

private displayTableData(data: any): void {
// this.tableData = data.json();
this.tableData = data;
}

deleteJobFile(filename, job_id) {
  if (confirm('Are you sure you want to delete this file? ')) {
    this._mysqlService.deleteJobFile(filename, job_id).subscribe(
       data => {
         // this.getTraceNotes(this.trace_id);
        this.refreshList();
         return true;
       },
       error => {
         console.error('Error deleting Job File!');
        return console.log(error);
       }
    );
}
}


getDate(){
  return new Date();
}





// drop down 


// multi select setup and action.
onItemSelect(item:any){
  // console.log(item);
   // this.createTraceAssignedUser(item); // insert into table
   // this.getTraceAssigned(item.trace_id); // refresh the list
   }
   onSelectAll(items: any){
  // console.log(items);
   };


   onItemSelectAssinged(item: any, job_id, user_id){
    // console.log(item);
    this.createJobAgentAssignedUser(item, job_id, user_id); // insert into table
   // added to auto start the strace
  //  this.startTraceDropdown(trace_id, this.sessionUserId);
    // this.getTraceAssigned(trace_id); // refresh the list
    // console.log(item, trace_id, user_id);
     };


     onSelectAllAssigned(items: any, job_id, user_id){
     console.log(items, job_id, user_id);
       // user id not passed.
     // TODO // need to create a delete all with trace_id from assigned_user table.
              this.deleteJobAgentAssignedAll(job_id);
             // this.toastr.success('Removed All Agents from Job');
             // test a loop
           //   const num2 = items;
             // delete loop
            /* num2.forEach(item => {
             this.deleteTraceAssignedAll(item.trace_id);
             });
             */



// TO DO // need to create an insert array of items mysql ... function. // maybe get from exec upload files fuction and sef_url etc..
// this.createTraceAssignedUserMultiple(items, trace_id);
             const num = items;
             // insert loop
             num.forEach(item => {
               console.log(item);
             this.createJobAgentAssignedUser(item, this.job_id, item.user_id); // did not work so place a copy here
             });


          // refresh the list
         // refresh the trace
     // this.startTraceDropdown(this.job_id, this.sessionUserId);
      // this.getTraceById(this.trace_id);

     
     };





     onDeSelectAssigned(item: any, job_id, user_id)
     {
       this.deleteJobAgentAssigned(item, job_id, item.user_id);
       this.toastr.success('Removed Agent from Job');
       // refresh the trace
      // this.getTraceById(this.trace_id);
       // console.log(item);
     };

/*
Callback Methods
onSelect - Return the selected item when an item is checked. Example : (onSelect)="onItemSelect($event)"
onSelectAll - Return the all items. Example : (onSelectAll)="onSelectAll($event)".
onDeSelect - Return the unselected item when an item is unchecked.
Example : (onDeSelect)="onItemDeSelect($event)" onFilterChange - Return the key press. Example : (onFilterChange)="onFilterChange($event)"

*/
// end drop down


// gets the list of users assiciated for drop down.
getBrandUsers(brand_id) {
  this._demoService.getBrandUsers(brand_id).subscribe(
     data => { this.staffList = data;
    },
     err => console.error(err),
     () => console.log('Candidates Loaded.')
   );
 }


 /*
 getTraceAssignedList(trace_id) {
  this._demoService.getTraceAssigned(trace_id).subscribe(
     data => { this.assigned_to_list = data;
    },
     err => console.error(err),
     () => console.log('Candidates Loaded.')
   );
 }
 */



 getJobAgentAssigned(job_id) {
  this._demoService.getJobAgentsAssigned(job_id).subscribe(
     data => { this.assignedList = data;
    },
     err => console.error(err),
     // () => console.log('Loaded Assigned Agents Loaded.')
   );
 }


 createJobAgentAssignedUser(item, job_id, user_id) {
  this._demoService.createJobAssigedAgent(item, job_id, user_id).subscribe(
     data => { // this.model = data;
       // refresh the list
      // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
     this.toastr.success('job Agents Updated');
     // Subject to reload the manager component parent.
    //  TraceCandidateManagerComponent.returned.next(false);
    // this.getTraceMysql(trace_id);
       return true;
     },
     error => {
       console.error('Error saving Job Agents Members!');
      return console.log(error);
     }
    // err => console.error(err),
    // () => console.log('done updates')
);
}

// not required and blank in _demo from delete
createTraceAssignedUserMultiple(items, job_id) {
  this._demoService.createTraceAssigedUserMultiple(items, job_id).subscribe(
     data => { // this.model = data;
       // refresh the list
      // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
     this.toastr.success('Trace Staff Members Updated');
     // Subject to reload the manager component parent.
    //  TraceCandidateManagerComponent.returned.next(false);
    // this.getTraceMysql(trace_id);
       return true;
     },
     error => {
       console.error('Error saving All Trace Staff Members!');
      return console.log(error);
     }
    // err => console.error(err),
    // () => console.log('done updates')
);
}



deleteJobAgentAssigned(item, job_id, user_id) {
    this._demoService.deleteJobAgentAssigned(item, job_id, user_id).subscribe(
       data => {
         // refresh the list
         this.getJobAgentAssigned(job_id);
         return true;
       },
       error => {
         console.error('Error removing user from list!');
        return console.log(error);
       }
    );

}


deleteJobAgentAssignedAll(job_id) {
  this._demoService.deleteJobAgentAssignedAll(job_id).subscribe(
     data => {
       // refresh the list
     //  this.getTraceAssigned(trace_id);
     this.getJobAgentAssigned(job_id);
       return true;
     },
     error => {
       console.error('Error removing all users from list!');
      return console.log(error);
     }
  );

}




// simply auto starts the trace on assignment of staff dropdown
startTraceDropdown(job_id, user_id) {
  user_id = this.sessionUserId; // sets the ID before its sent.


  this._demoService.startTraceDropdown(job_id, this.user_id).subscribe(
     data => { // this.model = data;
       // refresh the list
      // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
     this.toastr.warning('Trace Auto Started, Staff can now begin Subject Reporting.');
     // Subject to reload the manager component parent.
    //  TraceCandidateManagerComponent.returned.next(false);
    // this.getTraceMysql(model.trace_id);
   // this.getTraceById(trace_id);
       return true;
     },
     error => {
       // console.error('Error Starting Trace - Please Try Again!');
       this.toastr.error('Error Auto Starting Trace - Please Try Again!');
      return console.log(error);
     }
    // err => console.error(err),
    // () => console.log('done updates')
);
}


jobEdit(job_id) {
  this.router.navigate(['/admin/jobs/edit/' + job_id + '']);
}

jobView(job_id) {
  this.router.navigate(['/admin/jobs/view/' + job_id + '']);
}


 // GET CLIENT FROM BRANDS client - brand_report_id

 getReportBrand(brand_report_id) {
  this._demoService.getBrandById(brand_report_id).subscribe(
    data => {
      this.report_brand_brand = data;
   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
 }


 getInvoiceBrand(brand_invoice_id) {
  this._demoService.getBrandById(brand_invoice_id).subscribe(
    data => {
      this.invoice_brand_brand = data;
   },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
 }

// need to get user details
 getReportBrandUser(brand_report_user_id) {
  this._demoService.getUsersById(brand_report_user_id).subscribe(
     data => { this.report_brand_user = data; },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
 }




}


